"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.modelEqInterpreter = void 0;
var tslib_1 = require("tslib");
var utils_1 = require("@morphic-ts/common/lib/utils");
var intersections_1 = require("./model/intersections");
var newtype_1 = require("./model/newtype");
var object_1 = require("./model/object");
var primitives_1 = require("./model/primitives");
var recursive_1 = require("./model/recursive");
var refined_1 = require("./model/refined");
var set_1 = require("./model/set");
var str_map_1 = require("./model/str-map");
var tagged_unions_1 = require("./model/tagged-unions");
var unions_1 = require("./model/unions");
var unknown_1 = require("./model/unknown");
tslib_1.__exportStar(require("./hkt"), exports);
/**
 *  @since 0.0.1
 */
var allModelEq = function () {
    return utils_1.merge(unions_1.eqUnionInterpreter(), refined_1.eqRefinedInterpreter(), newtype_1.eqNewtypeInterpreter(), unknown_1.eqUnknownInterpreter(), primitives_1.eqPrimitiveInterpreter(), intersections_1.eqIntersectionInterpreter(), object_1.eqObjectInterpreter(), tagged_unions_1.eqTaggedUnionInterpreter(), recursive_1.eqRecursiveInterpreter(), str_map_1.eqStrMapInterpreter(), set_1.eqSetInterpreter());
};
/**
 *  @since 0.0.1
 */
exports.modelEqInterpreter = utils_1.memo(allModelEq);
